import { render, staticRenderFns } from "./DynamicLineChart.vue?vue&type=template&id=2fec2003&scoped=true&"
import script from "./DynamicLineChart.vue?vue&type=script&lang=ts&"
export * from "./DynamicLineChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec2003",
  null
  
)

export default component.exports